import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Chaos from "./sections/Chaos";
import CreativePillars from "./sections/CreativePillars";
import Showreel from "./sections/Showreel";
import Shop from "./sections/Shop";
import Categories from "./sections/Categories";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Chaos />
      <CreativePillars />
      <Showreel />
      <Shop />
      <Categories />
      <Footer />
    </div>;
}